import React from 'react';
import { FaFileCsv, FaUpload } from 'react-icons/fa';
import { TechSection, TechButton, TechInput, TechSelect, TechTextarea, TechChip } from '../../styles/techComponents';
import { PLATFORMS, TwoCol, FormRow, Label, Hint, FileDropZone, BatchResults } from './CreadorPerfilesStyles';

const BloqueCredenciales = (p) => (
  <TechSection title="Credenciales de la Cuenta" style={{ marginBottom: '1.25rem' }}>
    <TwoCol>
      <div className="col-left" style={{ display: 'flex', flexDirection: 'column', gap: '0.85rem' }}>
        <FormRow>
          <Label>Red Social</Label>
          <TechSelect value={p.platform} onChange={(e) => p.setPlatform(e.target.value)}>
            {PLATFORMS.map((x) => <option key={x.id} value={x.id}>{x.label}</option>)}
          </TechSelect>
        </FormRow>
        <FormRow><Label>Usuario / Email</Label><TechInput placeholder={'Usuario de ' + p.platformMeta.label + '...'} value={p.username} onChange={(e) => p.setUsername(e.target.value)} /></FormRow>
        <FormRow><Label>Contrasena</Label><TechInput type="password" placeholder="Contrasena..." value={p.password} onChange={(e) => p.setPassword(e.target.value)} /><Hint>Se encripta con AES-256.</Hint></FormRow>
      </div>
      <div className="col-right" style={{ display: 'flex', flexDirection: 'column', gap: '0.85rem' }}>
        <FormRow><Label>Cookies (opcional)</Label><TechTextarea placeholder="Pega las cookies de sesion..." value={p.cookies} onChange={(e) => p.setCookies(e.target.value)} rows={3} /><Hint>X: auth_token. LinkedIn: li_at. FB: c_user+xs.</Hint></FormRow>
        <FormRow><Label>Proxy Dedicado (opcional)</Label><TechInput placeholder="IP:Puerto:Usuario:Contrasena" value={p.proxy} onChange={(e) => p.setProxy(e.target.value)} /><Hint>Un proxy por cuenta.</Hint></FormRow>
        <FormRow>
          <Label>Subir en Lote (CSV)</Label>
          <FileDropZone onClick={() => p.fileRef.current?.click()}>
            <FaFileCsv /><div>Click para CSV</div>
            <Hint style={{ marginTop: 4 }}>Columnas: plataforma,usuario,password,proxy,cookies</Hint>
          </FileDropZone>
          <input ref={p.fileRef} type="file" accept=".csv,.txt" style={{ display: 'none' }} onChange={p.handleFileSelect} />
        </FormRow>
        {p.batchAccounts.length > 0 && (
          <div style={{ marginTop: '0.5rem' }}>
            <TechChip tone="mute">{p.batchAccounts.length} cuentas</TechChip>
            <TechButton type="button" onClick={p.handleBatchUpload} disabled={p.batchBusy} style={{ marginLeft: '0.5rem' }}>
              <FaUpload /> {p.batchBusy ? 'Subiendo...' : 'Cargar lote'}
            </TechButton>
          </div>
        )}
        {p.batchResult && (
          <BatchResults>
            {p.batchResult.created != null && <span className="ok">Creadas: {p.batchResult.created}</span>}
            {' '}{p.batchResult.updated != null && <span className="ok">Actualizadas: {p.batchResult.updated}</span>}
            {' '}{p.batchResult.errors?.length > 0 && <span className="err">Errores: {p.batchResult.errors.length}</span>}
            {p.batchResult.errors?.map((e, i) => <div key={i} className="err">#{e.index}: {e.error}</div>)}
          </BatchResults>
        )}
      </div>
    </TwoCol>
  </TechSection>
);

export default BloqueCredenciales;